import {
    createRouter,
    createWebHistory
} from "@ionic/vue-router"
import { RouteRecordRaw } from "vue-router"
import { checkAuthMiddleware } from "./checkAuthMiddleware"

const routes: Array<RouteRecordRaw> = [
    {
        name: "Default",
        path: "/",
        redirect: "/main/checkins",
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Deprecated",
        path: "/deprecated",
        component: () => import("@/pages/Deprecated.vue"),
        meta: {
            layout: "Default",
            requiresAuth: false
        }
    },
    {
        name: "Main",
        path: "/main/",
        component: () => import("@/pages/Main.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        },
        children: [
            {
                name: "Checkin-Index",
                path: "checkins",
                component: () => import("@/pages/Checkin/Index.vue")
            },
            {
                name: "Friends-Index",
                path: "friends",
                component: () => import("@/pages/Friends/Index.vue")
            },
            {
                name: "Journal",
                path: "journal",
                component: () => import("@/pages/Journal/Index.vue")
            },
            {
                name: "Account",
                path: "account",
                component: () => import("@/pages/Account/Index.vue")
            }
        ]
    },
    {
        name: "Login",
        path: "/login",
        component: () => import("@/pages/Auth/Login.vue"),
        meta: {
            layout: "Empty",
            requiresAuth: false
        }
    },
    {
        name: "Invite-Set",
        path: "/invite/:id",
        component: () => import("@/pages/Invite/Index.vue"),
        meta: {
            layout: "Default",
            requiresAuth: false
        }
    },
    {
        name: "Invite-Accept",
        path: "/invite",
        component: () => import("@/pages/Invite/Index.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Checkin-Create",
        path: "/checkin/create",
        component: () => import("@/pages/Checkin/CreateEdit.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Checkin-Edit",
        path: "/checkin/edit/:id",
        component: () => import("@/pages/Checkin/CreateEdit.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Checkin-Details",
        path: "/checkin/:id",
        component: () => import("@/pages/Checkin/Details.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Account-Edit",
        path: "/account/edit/",
        component: () => import("@/pages/Account/Edit.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "User-Profile",
        path: "/account/:id",
        component: () => import("@/pages/Account/User.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Article-Index",
        path: "/articles",
        component: () => import("@/pages/Articles/Index.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Article-Details",
        path: "/article/:id",
        component: () => import("@/pages/Articles/Details.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Recipe-Details",
        path: "/recipe/:id",
        component: () => import("@/pages/Recipe/Details.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Recipe-My",
        path: "/recipe/my",
        component: () => import("@/pages/Recipe/My.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Recipe-Create",
        path: "/recipe/create",
        component: () => import("@/pages/Recipe/CreateEdit.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Recipe-Edit",
        path: "/recipe/edit/:id",
        component: () => import("@/pages/Recipe/CreateEdit.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Notifications",
        path: "/notifications",
        component: () => import("@/pages/Notifications/Index.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "MyAchievements",
        path: "/achievements",
        component: () => import("@/pages/Achievements/Index.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "MyAchievement-Details",
        path: "/achievement/:id",
        component: () => import("@/pages/Achievements/Details.vue"),
        meta: {
            layout: "Default",
            requiresAuth: false
        }
    },
    {
        name: "UserAchievements",
        path: "/achievements/:id",
        component: () => import("@/pages/Achievements/UserAchievements.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "Settings",
        path: "/settings",
        component: () => import("@/pages/Settings/Index.vue"),
        meta: {
            layout: "Default",
            requiresAuth: true
        }
    },
    {
        name: "TestPage",
        path: "/test",
        component: () => import("@/pages/Test/TestPage.vue"),
        meta: {
            layout: "Default",
            requiresAuth: false
        }
    }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

router.beforeEach(checkAuthMiddleware)

export default router
